import { Component, Input, OnInit } from '@angular/core';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { CONSTANTS } from 'src/app/shared/constants/constants';

@Component({
  selector: 'app-remaining-invite-dialog',
  templateUrl: './remaining-invite-dialog.component.html',
  styleUrls: ['./remaining-invite-dialog.component.scss'],
})
export class RemainingInviteDialogComponent implements OnInit {
  ngOnInit(): void {
    if (window.__dev__) console.log("'Method not implemented.'");
  }
  readonly LANG_CONST = LANG_CONST;
  readonly CONSTANTS = CONSTANTS;

  @Input() recurrentRevenue: any;
  readonly MAX_DEFAULT_INVITE = 250;

  inviteExceed() {
    const accepted = this.recurrentRevenue.invitesAcceptedCount ?? 0;
    const total = this.recurrentRevenue.totalInvites ?? this.MAX_DEFAULT_INVITE;
    return accepted >= total;
  }
}
